import { render } from "./MemberArea.vue?vue&type=template&id=4f803a27&scoped=true"
import script from "./MemberArea.vue?vue&type=script&lang=js"
export * from "./MemberArea.vue?vue&type=script&lang=js"

import "./MemberArea.vue?vue&type=style&index=0&id=4f803a27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f803a27"]])

export default __exports__